import { render, staticRenderFns } from "./ClubsItemActivator.vue?vue&type=template&id=7b0c0c0f"
import script from "./ClubsItemActivator.vue?vue&type=script&lang=js"
export * from "./ClubsItemActivator.vue?vue&type=script&lang=js"
import style0 from "./ClubsItemActivator.vue?vue&type=style&index=0&id=7b0c0c0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports